var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "search-output",
      class: { "is-last-minute": _vm.isLastMinute === true },
    },
    [
      _vm.hasSearchTop
        ? _c(
            "div",
            {
              staticClass: "search-top searchTopBottom",
              class: { "force-top": _vm.forceSearchTop },
            },
            [_vm._t("search-top")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.lodgings.length > 0
        ? _vm._l(_vm.lodgings, function (lodging, index) {
            return _c("feriehus-item", {
              key: lodging.position,
              attrs: {
                lodging: lodging,
                displayLastMinuteHeader: _vm.displayLastMinuteHeader(index),
              },
            })
          })
        : _c("no-results"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }